import { BasicDataType, SupplierType } from "operations/schema/schema";

export type PartFilter = {
  selectedSuppliers: SupplierType[];
  sortGroup1: BasicDataType[];
  sortGroup2: BasicDataType[];
  sortGroup3: BasicDataType[];
  sortGroup4: BasicDataType[];
  sortGroup5: BasicDataType[];
};

export const defaultPartFilter: PartFilter = {
  selectedSuppliers: [],
  sortGroup1: [],
  sortGroup2: [],
  sortGroup3: [],
  sortGroup4: [],
  sortGroup5: [],
};

type FilterKeys = (keyof typeof defaultPartFilter)[];
export const PartFilterKeys: FilterKeys = Object.keys(defaultPartFilter) as FilterKeys;
